import { render, staticRenderFns } from "./AchievementModal.vue?vue&type=template&id=3c9bedf3&scoped=true&"
import script from "./AchievementModal.vue?vue&type=script&lang=js&"
export * from "./AchievementModal.vue?vue&type=script&lang=js&"
import style0 from "./AchievementModal.vue?vue&type=style&index=0&id=3c9bedf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9bedf3",
  null
  
)

export default component.exports